module.exports = __webpack_public_path__ + "site/img/100.7758af40.jpg";